<template>
  <tr @click="goToDetail">
    <td class="product-remove">
      <p class="remove" @click.stop="$emit('remove', {line})">x</p>
    </td>
    <td class="product-thumbnail">
      <LineItemThumbnails :preview_urls="line.preview_urls" :rounded="lineIsRounded"/>
    </td>
    <td class="product-name">
    <span placement="right" v-b-tooltip.hover :title="line.product.title">
      {{line.product.title.substr(0,40) + '...'}}
      <!-- debugging tool, turn on debugTools to see it -->
      <pre
        style="text-align: left; font-size: small; border: 3px dashed blue;"
        v-if="flags.debugTools">ordered_for:{{line.ordered_for_id}}</pre>
    </span>
    </td>
    <!-- <td class="product-price">
      <span class="amount">{{unitPrice.toFixed(2)}}</span>
    </td> -->
    <td class="product-box-size">
      <span>{{boxSize}}</span>
    </td>
    <!-- <td class="product-quantity">
      <div class="quantity">
        <input type="button" value="+" class="plus" @click="plus()">
        <input type="number" step="1" title="Qty"
               class="qty" size="4" :value="line.quantity" @input="changeQty(parseInt(this.value, 10))">
        <input type="button" value="-" class="minus" @click="minus()">
      </div>
    </td> -->
    <td class="product-subtotal">
      <span class="amount">{{totalPrice.toFixed(2)}}</span>
    </td>
  </tr>

</template>
<script>
  import {isRounded} from "@/lib/productAttrs";
  import {mapGetters} from 'vuex';
  export default{
    props: {
      line: {
        type: Object
      }
    },
    computed: {
      ...mapGetters(['flags']),
      unitPrice() {
        return this.totalPrice / this.line.quantity;
      },
      totalPrice() {
        return parseFloat(this.line.price_excl_tax, 10);
      },
      boxSize() {
        return this.line.boxSize;
      },
      lineIsRounded() {
        return isRounded(this.line.product);
      }
    },
    methods: {
      changeQty(quantity) {
        this.$emit('changeQty', {quantity, line: this.line});
      },
      plus() {
        this.changeQty(this.line.quantity+1);
      },
      minus() {
        if (this.line.quantity > 0) {
          this.changeQty(this.line.quantity-1);
        }
      },
      goToDetail() {
        this.$router.push({name: "Cart Detail", params: {id: this.line.id}});
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '~scss/abstracts/_variables.scss';
  @import '~bootstrap/scss/_functions';
  @import '~bootstrap/scss/_variables';
  @import "~bootstrap/scss/_mixins";

  td {
    padding: .75rem;
    vertical-align: middle;
  }

  .product-remove {
    font-size: 20px;

  .remove {
    cursor: pointer;
    margin-bottom: 0;

  &:hover {
     color: $red;
   }
  }
  }

  .product-thumbnail {
    width: 20%;
    padding: 10px;

  .col {
    position: inherit;
  }
  }

  .product-name > a {
    font-size: 16px;
  }

  .product-price {
    color: #323237;
    font-size: 14px;
    font-weight: 300;
    margin: 0;
  }


  .product-subtotal {
    font-weight: bold;
  }

  .product-subtotal {
    color: get-theme-color('accent');
  }

  .svg-popup-template {
    z-index: 100;

  @include media-breakpoint-up(xs) {
    width: 300px;
    max-width: 300px;
  }

  @include media-breakpoint-up(md) {
    width: 500px;
    max-width: 500px;
  }

  }

  .page {
    width: 100%;
  }

  svg {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/basket/LineItem.vue